// Login
export const storeLoginToken = "storeLoginToken";
export const removeLoginToken = "removeLoginToken";
export const sessionExpired = "sessionExpired";
export const userSession = "userSession";
export const userSessionAuthenticate = "userSessionAuthenticate";
export const isLoadingAction = "isLoading";